import * as tslib_1 from "tslib";
import { store } from '../../index';
import { settings } from '../../settings';
import ContextCreator from '../../websiteStateEngine/util/ContextCreator';
import ObjectToGetParameterMapper from '../mapper/ObjectToGetParameterMapper';
import DepartureAirportMapper from '../util/DepartureAirportMapper';
var FormDataClient = /** @class */ (function () {
    function FormDataClient() {
    }
    FormDataClient.fetchAndDispatchFormDataAsync = function (productType, formDataAction, filterAirports) {
        if (filterAirports === void 0) { filterAirports = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var protocol, apiEndpoint, coreBaseUrl, endpointUrl, context, parameterString, dynamicDestinations;
            return tslib_1.__generator(this, function (_a) {
                protocol = store.getState().websiteState.app.location.protocol;
                apiEndpoint = settings.coreApi.endPoints.formData;
                coreBaseUrl = settings.coreApi.host + settings.coreApi.prefix;
                endpointUrl = protocol + '//' + coreBaseUrl + apiEndpoint + '/available';
                context = ContextCreator.create(store.getState());
                context.flatGroups = true;
                context.productType = productType;
                parameterString = ObjectToGetParameterMapper.map(context);
                dynamicDestinations = window['dynamicDestinations'] ? '&dynamicDestinations=true' : '';
                fetch(endpointUrl + '?' + parameterString + dynamicDestinations, {
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(function (response) {
                    if (response.status === 200) {
                        response.json().then(function (data) {
                            if (filterAirports) {
                                formDataAction.formData = DepartureAirportMapper.filter(data);
                            }
                            else {
                                formDataAction.formData = data;
                            }
                            store.dispatch(formDataAction);
                        });
                    }
                    else {
                        console.error('Error while fetching products', response.status, response);
                        store.dispatch(formDataAction);
                    }
                }).catch(function (error) {
                    console.error('Error while fetching products', error);
                    store.dispatch(formDataAction);
                });
                return [2 /*return*/];
            });
        });
    };
    return FormDataClient;
}());
export default FormDataClient;
